(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("currency.js"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "currency.js"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("currency.js")) : factory(root["react"], root["currency.js"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__) {
return 